import React, { useState, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { useAuth } from '../../context/AuthContext';

const Layout: React.FC = () => {
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { userRole, user } = useAuth();
  
  const toggleMobileSidebar = () => {
    setIsMobileOpen(!isMobileOpen);
  };
  
  // Redirect non-admin users from dashboard to appropriate page
  // Only if they're directly accessing the root path
  useEffect(() => {
    if (location.pathname === '/' && userRole && userRole !== 'Administrador' && user) {
      // Store this redirection in localStorage
      let redirectPath = '/';
      
      if (userRole === 'Vendedor') {
        redirectPath = '/express';
      } else if (userRole === 'Producción') {
        redirectPath = '/productionmanager';
      } else if (userRole === 'Depósito') {
        redirectPath = '/express/stock';
      }
      
      localStorage.setItem('lastPath', redirectPath);
      navigate(redirectPath);
    }
  }, [location.pathname, userRole, navigate, user]);
  
  // Generate title based on current route
  const getTitle = () => {
    switch (location.pathname) {
      case '/':
        return 'Dashboard';
      case '/clientes':
        return 'Clientes';
      case '/proveedores':
        return 'Proveedores';
      case '/remitos':
        return 'Remitos';
      case '/facturas':
        return 'Facturas';
      case '/reportes':
        return 'Reportes';
      case '/pedidos':
        return 'Pedidos';
      case '/producciones':
        return 'PRO';
      case '/productionmanager':
        return 'Producción';
      case '/productionadmin':
        return 'Administración';
      case '/muestras':
        return 'Muestras';
      case '/express':
        return 'Express';
      case '/express/stock':
        return 'Stock Express';
      case '/express/muestras':
        return 'Muestras Express';
      case '/configuracion':
        return 'Configuración';
      case '/asistente':
        return 'Asistente';
      case '/todolist':
        return 'To-Do Diario';
      case '/usuarios':
        return 'Gestión de Usuarios';
      case '/chat/envios':
        return 'Chat de Envíos';
      case '/actividad':
        return 'Actividad';
      case '/gastos':
        return 'Gastos';
      case '/tesoreria':
        return 'Tesorería';
     case '/logistics':
       return 'Logística';
      default:
        if (location.pathname.startsWith('/clientes/')) {
          return 'Cuenta de Cliente';
        }
        if (location.pathname.startsWith('/proveedores/')) {
          return 'Cuenta de Proveedor';
        }
        return 'Productex';
    }
  };
  
  return (
    <div className="flex h-screen bg-gray-50 dark:bg-gray-900">
      <Sidebar 
        isMobileOpen={isMobileOpen} 
        toggleMobileSidebar={toggleMobileSidebar} 
      />
      
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header 
          title={getTitle()} 
          toggleMobileSidebar={toggleMobileSidebar} 
        />
        
        <main className="flex-1 overflow-auto p-4 sm:p-6 lg:p-8 bg-gray-50 dark:bg-gray-900">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;